(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-cafe-article"]) return;
  try {
    
  // このスクリプトは、関連記事セクションの位置を画面幅に応じて変更します。
  document.addEventListener('DOMContentLoaded', function() {
    const relatedPostsElement = document.querySelector('.sidebar-related-container');
    // 関連記事セクションが見つからなければ何もしない
    if (!relatedPostsElement) return;

    // スマホの場合（989px以下）
    if (window.matchMedia('(max-width: 989px)').matches) {
      const articleContentElement = document.querySelector('.article-content');
      if (articleContentElement) {
        articleContentElement.after(relatedPostsElement);
      }
    } 
     
    // PCの場合（990px以上）
    else {
      const tocElement = document.querySelector('.table-of-contents');
      if (tocElement) {
        tocElement.after(relatedPostsElement);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
